interface BrowserCallLogoProps {
  fill: string;
}

/* §FB175: іконка вкладки «Дзвінки з браузера» — вікно браузера з камерою. */
const BrowserCallLogo = ({ fill }: BrowserCallLogoProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 2.5h13a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2v-11a2 2 0 0 1 2-2Zm0 1.5a.5.5 0 0 0-.5.5V6h14V4.5a.5.5 0 0 0-.5-.5h-13ZM17 7.5H3v8a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-8Z"
      fill={fill}
      opacity="0.45"
    />
    <path
      d="M5.5 9.25c0-.69.56-1.25 1.25-1.25h4.5c.69 0 1.25.56 1.25 1.25v.6l1.66-1.03a.6.6 0 0 1 .92.51v4.34a.6.6 0 0 1-.92.51l-1.66-1.03v.6c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25v-4.5Z"
      fill={fill}
    />
  </svg>
);

export default BrowserCallLogo;
